module.exports = __webpack_public_path__ + "static/media/newarrival-4.879471a3.jpg";